import React, { useState } from 'react';
import { SearchIcon, FilterIcon } from 'lucide-react';
import { GlobeVisualization } from '../components/Globe';
import { MusicPanel } from '../components/MusicPanel';
export function Globe() {
  const [showList, setShowList] = useState(false);
  const [selectedLocation, setSelectedLocation] = useState(null);
  const [isPanelExpanded, setIsPanelExpanded] = useState(true);
  // Sample data for music listening locations with multiple songs per location
  const musicLocations = [{
    id: 1,
    lat: 40.7128,
    lng: -74.006,
    location: 'New York City',
    songs: [{
      id: 101,
      title: 'Empire State of Mind',
      artist: 'Jay-Z ft. Alicia Keys',
      album: 'The Blueprint 3',
      albumCover: 'https://images.unsplash.com/photo-1500462918059-b1a0cb512f1d?ixlib=rb-1.2.1&auto=format&fit=crop&w=300&q=80'
    }, {
      id: 102,
      title: 'New York, New York',
      artist: 'Frank Sinatra',
      album: 'Trilogy: Past Present Future',
      albumCover: 'https://images.unsplash.com/photo-1496743164551-c49f5b52f2f7?ixlib=rb-1.2.1&auto=format&fit=crop&w=300&q=80'
    }, {
      id: 103,
      title: 'Welcome to New York',
      artist: 'Taylor Swift',
      album: '1989',
      albumCover: 'https://images.unsplash.com/photo-1557787163-1635e2efb160?ixlib=rb-1.2.1&auto=format&fit=crop&w=300&q=80'
    }, {
      id: 104,
      title: 'Brooklyn Baby',
      artist: 'Lana Del Rey',
      album: 'Ultraviolence',
      albumCover: 'https://images.unsplash.com/photo-1478737270239-2f02b77fc618?ixlib=rb-1.2.1&auto=format&fit=crop&w=300&q=80'
    }, {
      id: 105,
      title: 'Manhattan',
      artist: 'Cat Power',
      album: 'Sun',
      albumCover: 'https://images.unsplash.com/photo-1522083165195-3424ed129620?ixlib=rb-1.2.1&auto=format&fit=crop&w=300&q=80'
    }, {
      id: 106,
      title: 'Harlem Shuffle',
      artist: 'The Rolling Stones',
      album: 'Tattoo You',
      albumCover: 'https://images.unsplash.com/photo-1518609878373-06d740f60d8b?ixlib=rb-1.2.1&auto=format&fit=crop&w=300&q=80'
    }]
  }, {
    id: 2,
    lat: 48.8566,
    lng: 2.3522,
    location: 'Paris',
    songs: [{
      id: 201,
      title: 'La Vie En Rose',
      artist: 'Edith Piaf',
      album: 'La Vie En Rose',
      albumCover: 'https://images.unsplash.com/photo-1614613535308-eb5fbd3d2c17?ixlib=rb-1.2.1&auto=format&fit=crop&w=300&q=80'
    }, {
      id: 202,
      title: 'Paris',
      artist: 'The Chainsmokers',
      album: 'Memories...Do Not Open',
      albumCover: 'https://images.unsplash.com/photo-1502602898657-3e91760cbb34?ixlib=rb-1.2.1&auto=format&fit=crop&w=300&q=80'
    }, {
      id: 203,
      title: 'Sous le Ciel de Paris',
      artist: 'Yves Montand',
      album: 'The Best of Yves Montand',
      albumCover: 'https://images.unsplash.com/photo-1499856871958-5b9627545d1a?ixlib=rb-1.2.1&auto=format&fit=crop&w=300&q=80'
    }, {
      id: 204,
      title: 'April in Paris',
      artist: 'Ella Fitzgerald & Louis Armstrong',
      album: 'Ella and Louis Again',
      albumCover: 'https://images.unsplash.com/photo-1550340499-a6c60f275b6e?ixlib=rb-1.2.1&auto=format&fit=crop&w=300&q=80'
    }, {
      id: 205,
      title: 'Midnight in Paris',
      artist: 'Sidney Bechet',
      album: 'The Best of Sidney Bechet',
      albumCover: 'https://images.unsplash.com/photo-1550089479-fe0e48e7d788?ixlib=rb-1.2.1&auto=format&fit=crop&w=300&q=80'
    }]
  }, {
    id: 3,
    lat: 35.6762,
    lng: 139.6503,
    location: 'Tokyo',
    songs: [{
      id: 301,
      title: 'Lost in Japan',
      artist: 'Shawn Mendes',
      album: 'Shawn Mendes',
      albumCover: 'https://images.unsplash.com/photo-1511671782779-c97d3d27a1d4?ixlib=rb-1.2.1&auto=format&fit=crop&w=300&q=80'
    }, {
      id: 302,
      title: 'Tokyo Drift',
      artist: 'Teriyaki Boyz',
      album: 'Fast and Furious: Tokyo Drift OST',
      albumCover: 'https://images.unsplash.com/photo-1503899036084-c55cdd92da26?ixlib=rb-1.2.1&auto=format&fit=crop&w=300&q=80'
    }, {
      id: 303,
      title: 'Plastic Love',
      artist: 'Mariya Takeuchi',
      album: 'Variety',
      albumCover: 'https://images.unsplash.com/photo-1492571350019-22de08371fd3?ixlib=rb-1.2.1&auto=format&fit=crop&w=300&q=80'
    }, {
      id: 304,
      title: 'Tokyo',
      artist: 'Vampire Weekend',
      album: 'Father of the Bride',
      albumCover: 'https://images.unsplash.com/photo-1551641506-ee5bf4cb45f1?ixlib=rb-1.2.1&auto=format&fit=crop&w=300&q=80'
    }, {
      id: 305,
      title: 'Midnight City',
      artist: 'M83',
      album: "Hurry Up, We're Dreaming",
      albumCover: 'https://images.unsplash.com/photo-1515169067868-5387ec356754?ixlib=rb-1.2.1&auto=format&fit=crop&w=300&q=80'
    }]
  }, {
    id: 4,
    lat: -33.8688,
    lng: 151.2093,
    location: 'Sydney',
    songs: [{
      id: 401,
      title: 'Down Under',
      artist: 'Men at Work',
      album: 'Business as Usual',
      albumCover: 'https://images.unsplash.com/photo-1500462918059-b1a0cb512f1d?ixlib=rb-1.2.1&auto=format&fit=crop&w=300&q=80'
    }, {
      id: 402,
      title: 'Sydney',
      artist: 'Brett Dennen',
      album: 'Smoke and Mirrors',
      albumCover: 'https://images.unsplash.com/photo-1506973035872-a4ec16b8e8d9?ixlib=rb-1.2.1&auto=format&fit=crop&w=300&q=80'
    }, {
      id: 403,
      title: 'Great Southern Land',
      artist: 'Icehouse',
      album: 'Primitive Man',
      albumCover: 'https://images.unsplash.com/photo-1523482580672-f109ba8cb9be?ixlib=rb-1.2.1&auto=format&fit=crop&w=300&q=80'
    }, {
      id: 404,
      title: 'Throw Your Arms Around Me',
      artist: 'Hunters & Collectors',
      album: 'Human Frailty',
      albumCover: 'https://images.unsplash.com/photo-1477064996809-dae46985eee7?ixlib=rb-1.2.1&auto=format&fit=crop&w=300&q=80'
    }, {
      id: 405,
      title: 'Beds Are Burning',
      artist: 'Midnight Oil',
      album: 'Diesel and Dust',
      albumCover: 'https://images.unsplash.com/photo-1493514789931-586cb221d7a7?ixlib=rb-1.2.1&auto=format&fit=crop&w=300&q=80'
    }]
  }, {
    id: 5,
    lat: 51.5074,
    lng: -0.1278,
    location: 'London',
    songs: [{
      id: 601,
      title: 'London Calling',
      artist: 'The Clash',
      album: 'London Calling',
      albumCover: 'https://images.unsplash.com/photo-1513635269975-59663e0ac1ad?ixlib=rb-1.2.1&auto=format&fit=crop&w=300&q=80'
    }, {
      id: 602,
      title: 'Waterloo Sunset',
      artist: 'The Kinks',
      album: 'Something Else by The Kinks',
      albumCover: 'https://images.unsplash.com/photo-1494922275507-58dc039ed337?ixlib=rb-1.2.1&auto=format&fit=crop&w=300&q=80'
    }, {
      id: 603,
      title: 'West End Girls',
      artist: 'Pet Shop Boys',
      album: 'Please',
      albumCover: 'https://images.unsplash.com/photo-1529655683826-aba9b3e77383?ixlib=rb-1.2.1&auto=format&fit=crop&w=300&q=80'
    }, {
      id: 604,
      title: 'Electric Avenue',
      artist: 'Eddy Grant',
      album: 'Killer on the Rampage',
      albumCover: 'https://images.unsplash.com/photo-1514525253161-7a46d19cd819?ixlib=rb-1.2.1&auto=format&fit=crop&w=300&q=80'
    }, {
      id: 605,
      title: 'Baker Street',
      artist: 'Gerry Rafferty',
      album: 'City to City',
      albumCover: 'https://images.unsplash.com/photo-1543872084-c7bd3822856f?ixlib=rb-1.2.1&auto=format&fit=crop&w=300&q=80'
    }]
  }, {
    id: 6,
    lat: 37.7749,
    lng: -122.4194,
    location: 'San Francisco',
    songs: [{
      id: 1101,
      title: "If You're Going to San Francisco",
      artist: 'Scott McKenzie',
      album: 'The Voice of Scott McKenzie',
      albumCover: 'https://images.unsplash.com/photo-1501594907352-04cda38ebc29?ixlib=rb-1.2.1&auto=format&fit=crop&w=300&q=80'
    }, {
      id: 1102,
      title: 'Lights',
      artist: 'Journey',
      album: 'Infinity',
      albumCover: 'https://images.unsplash.com/photo-1506146332389-18140dc7b2fb?ixlib=rb-1.2.1&auto=format&fit=crop&w=300&q=80'
    }, {
      id: 1103,
      title: 'San Francisco (Be Sure to Wear Flowers in Your Hair)',
      artist: 'Scott McKenzie',
      album: 'The Voice of Scott McKenzie',
      albumCover: 'https://images.unsplash.com/photo-1551383616-a1d65d2c52a9?ixlib=rb-1.2.1&auto=format&fit=crop&w=300&q=80'
    }, {
      id: 1104,
      title: "Sittin' on the Dock of the Bay",
      artist: 'Otis Redding',
      album: 'The Dock of the Bay',
      albumCover: 'https://images.unsplash.com/photo-1468581264429-2548ef9eb732?ixlib=rb-1.2.1&auto=format&fit=crop&w=300&q=80'
    }, {
      id: 1105,
      title: 'I Left My Heart in San Francisco',
      artist: 'Tony Bennett',
      album: 'I Left My Heart in San Francisco',
      albumCover: 'https://images.unsplash.com/photo-1554118811-1e0d58224f24?ixlib=rb-1.2.1&auto=format&fit=crop&w=300&q=80'
    }]
  },
  // New locations
  {
    id: 7,
    lat: 19.4326,
    lng: -99.1332,
    location: 'Mexico City',
    songs: [{
      id: 701,
      title: 'La Bamba',
      artist: 'Ritchie Valens',
      album: 'Ritchie Valens',
      albumCover: 'https://images.unsplash.com/photo-1513002749550-c59d786b8e6c?ixlib=rb-1.2.1&auto=format&fit=crop&w=300&q=80'
    }, {
      id: 702,
      title: 'Cielito Lindo',
      artist: 'Mariachi Vargas de Tecalitlán',
      album: 'The Best of Mariachi',
      albumCover: 'https://images.unsplash.com/photo-1518098268026-4e89f1a2cd8a?ixlib=rb-1.2.1&auto=format&fit=crop&w=300&q=80'
    }, {
      id: 703,
      title: 'Mexico',
      artist: 'James Taylor',
      album: 'Gorilla',
      albumCover: 'https://images.unsplash.com/photo-1566838330491-5037617a2da1?ixlib=rb-1.2.1&auto=format&fit=crop&w=300&q=80'
    }, {
      id: 704,
      title: 'Despacito',
      artist: 'Luis Fonsi ft. Daddy Yankee',
      album: 'Vida',
      albumCover: 'https://images.unsplash.com/photo-1496309732348-3627f3f040ee?ixlib=rb-1.2.1&auto=format&fit=crop&w=300&q=80'
    }]
  }, {
    id: 8,
    lat: -22.9068,
    lng: -43.1729,
    location: 'Rio de Janeiro',
    songs: [{
      id: 801,
      title: 'The Girl from Ipanema',
      artist: 'Stan Getz & Astrud Gilberto',
      album: 'Getz/Gilberto',
      albumCover: 'https://images.unsplash.com/photo-1516834474-48c0abc2a902?ixlib=rb-1.2.1&auto=format&fit=crop&w=300&q=80'
    }, {
      id: 802,
      title: 'Mas Que Nada',
      artist: "Sergio Mendes & Brasil '66",
      album: 'Herb Alpert Presents',
      albumCover: 'https://images.unsplash.com/photo-1518639192441-8fce0a366e2e?ixlib=rb-1.2.1&auto=format&fit=crop&w=300&q=80'
    }, {
      id: 803,
      title: 'Aquarela do Brasil',
      artist: 'João Gilberto',
      album: 'João Gilberto in Tokyo',
      albumCover: 'https://images.unsplash.com/photo-1518105779142-d975f22f1b0a?ixlib=rb-1.2.1&auto=format&fit=crop&w=300&q=80'
    }, {
      id: 804,
      title: 'Samba de Janeiro',
      artist: 'Bellini',
      album: 'Samba de Janeiro',
      albumCover: 'https://images.unsplash.com/photo-1483729558449-99ef09a8c325?ixlib=rb-1.2.1&auto=format&fit=crop&w=300&q=80'
    }]
  }, {
    id: 9,
    lat: 41.9028,
    lng: 12.4964,
    location: 'Rome',
    songs: [{
      id: 901,
      title: 'Roman Holiday',
      artist: 'Nicki Minaj',
      album: 'Pink Friday: Roman Reloaded',
      albumCover: 'https://images.unsplash.com/photo-1552832230-c0197dd311b5?ixlib=rb-1.2.1&auto=format&fit=crop&w=300&q=80'
    }, {
      id: 902,
      title: 'Arrivederci Roma',
      artist: 'Dean Martin',
      album: 'This Is Dean Martin',
      albumCover: 'https://images.unsplash.com/photo-1529260830199-42c24126f198?ixlib=rb-1.2.1&auto=format&fit=crop&w=300&q=80'
    }, {
      id: 903,
      title: "That's Amore",
      artist: 'Dean Martin',
      album: 'Dino: The Essential Dean Martin',
      albumCover: 'https://images.unsplash.com/photo-1515542622106-78bda8ba0e5b?ixlib=rb-1.2.1&auto=format&fit=crop&w=300&q=80'
    }, {
      id: 904,
      title: 'Volare',
      artist: 'Dean Martin',
      album: 'This Is Dean Martin',
      albumCover: 'https://images.unsplash.com/photo-1516483638261-f4dbaf036963?ixlib=rb-1.2.1&auto=format&fit=crop&w=300&q=80'
    }]
  }, {
    id: 10,
    lat: 25.2048,
    lng: 55.2708,
    location: 'Dubai',
    songs: [{
      id: 1001,
      title: 'Desert Rose',
      artist: 'Sting ft. Cheb Mami',
      album: 'Brand New Day',
      albumCover: 'https://images.unsplash.com/photo-1512958789358-4dac0f02f42d?ixlib=rb-1.2.1&auto=format&fit=crop&w=300&q=80'
    }, {
      id: 1002,
      title: 'Arabian Nights',
      artist: 'Will Smith',
      album: 'Aladdin (2019 Soundtrack)',
      albumCover: 'https://images.unsplash.com/photo-1517444097804-2a63cca56ef3?ixlib=rb-1.2.1&auto=format&fit=crop&w=300&q=80'
    }, {
      id: 1003,
      title: 'Dubai Drip',
      artist: 'Offset',
      album: 'Father of 4',
      albumCover: 'https://images.unsplash.com/photo-1518684079-3c830dcef090?ixlib=rb-1.2.1&auto=format&fit=crop&w=300&q=80'
    }, {
      id: 1004,
      title: 'Sandstorm',
      artist: 'Darude',
      album: 'Before the Storm',
      albumCover: 'https://images.unsplash.com/photo-1509316785289-025f5b846b35?ixlib=rb-1.2.1&auto=format&fit=crop&w=300&q=80'
    }]
  }];
  // Function to filter out songs with city name in title and get random songs
  const getRandomSongs = (location, count = 3) => {
    if (!location || !location.songs || location.songs.length === 0) return [];
    // Get the city name and any common variations to filter out
    const cityName = location.location.toLowerCase();
    const cityVariations = cityName.split(' ');
    // Filter out songs that contain the city name in their title
    const filteredSongs = location.songs.filter(song => {
      const songTitle = song.title.toLowerCase();
      // Check if song title contains the full city name or any part of it
      return !cityVariations.some(part => part.length > 2 && songTitle.includes(part)) && !songTitle.includes(cityName);
    });
    // If we filtered out all songs, use the original list
    const songsToUse = filteredSongs.length > 0 ? filteredSongs : location.songs;
    // Shuffle the songs array and get up to 'count' songs
    const shuffled = [...songsToUse].sort(() => 0.5 - Math.random());
    return shuffled.slice(0, Math.min(count, shuffled.length));
  };
  const handleLocationSelect = locationId => {
    const location = musicLocations.find(loc => loc.id === locationId);
    if (location) {
      // Create a copy of the location with randomized songs
      const locationWithRandomSongs = {
        ...location,
        randomSongs: getRandomSongs(location)
      };
      setSelectedLocation(locationWithRandomSongs);
      setIsPanelExpanded(true); // Expand panel when new location is selected
    }
  };
  const togglePanel = () => {
    setIsPanelExpanded(!isPanelExpanded);
  };
  return <div className="h-full w-full flex flex-col" data-id="element-183">
      {/* Header */}
      <div className="px-4 py-5 flex justify-between items-center" data-id="element-184">
        <h1 className="text-2xl font-bold" data-id="element-185">Your Music Map</h1>
        <div className="flex space-x-2" data-id="element-186">
          <button className="w-9 h-9 rounded-full bg-zinc-800 flex items-center justify-center" data-id="element-187">
            <SearchIcon size={18} data-id="element-188" />
          </button>
          <button className="w-9 h-9 rounded-full bg-zinc-800 flex items-center justify-center" data-id="element-189">
            <FilterIcon size={18} data-id="element-190" />
          </button>
        </div>
      </div>
      {/* Globe visualization with new interactive features */}
      <div className="flex-1 relative" data-id="element-191">
        {/* Use the renamed component */}
        <div className="absolute inset-0 z-5" data-id="element-192">
          <GlobeVisualization locations={musicLocations} onSelectLocation={handleLocationSelect} selectedLocationId={selectedLocation?.id} data-id="element-193" />
        </div>
        {/* Music panel with higher z-index to appear above the globe */}
        {selectedLocation && <MusicPanel location={selectedLocation} isExpanded={isPanelExpanded} onToggleExpand={togglePanel} data-id="element-194" />}
        {/* Info overlay with lower z-index to not block globe interactions */}
        {!selectedLocation && <div className="absolute bottom-4 left-4 right-4 bg-black/70 backdrop-blur-sm p-3.5 rounded-lg z-1" data-id="element-195">
            <p className="text-sm text-zinc-300 mb-1" data-id="element-196">
              Your music has been played in{' '}
              <span className="text-green-500 font-bold" data-id="element-197">
                {musicLocations.length} locations
              </span>{' '}
              around the world
            </p>
            <p className="text-xs text-zinc-400" data-id="element-198">
              Click on a point to see what you listened to there
            </p>
          </div>}
      </div>
    </div>;
}